import { adminNotificationConstants } from "../actions/constants";
import { canAccessPath } from "./adminAccess";

export const notificationActions = {
    ...adminNotificationConstants,
    SET_OWNER: "ADMIN_NOTIFICATIONS_SET_OWNER",
    CLEAR: "ADMIN_NOTIFICATIONS_CLEAR",
    FETCH_PAGE_REQUEST: "ADMIN_NOTIFICATIONS_FETCH_PAGE_REQUEST",
    FETCH_PAGE_FAILURE: "ADMIN_NOTIFICATIONS_FETCH_PAGE_FAILURE",
    COUNTS_REQUEST: "ADMIN_NOTIFICATIONS_COUNTS_REQUEST",
    COUNTS_SUCCESS: "ADMIN_NOTIFICATIONS_COUNTS_SUCCESS",
    COUNTS_FAILURE: "ADMIN_NOTIFICATIONS_COUNTS_FAILURE",
    MARK_ALL_READ: "ADMIN_NOTIFICATIONS_MARK_ALL_READ",
};

export const notificationTypes = [
    { key: "", label: "Все" },
    { key: "order", label: "Заказы" },
    { key: "lead", label: "Заявки" },
    { key: "user", label: "Регистрации" },
    { key: "subscription", label: "Подписки" },
    { key: "payment", label: "Оплаты" },
    { key: "chat", label: "Сообщения" },
    { key: "system", label: "Система" },
];

export const notificationFilters = { from: null, to: null, sort: "desc", limit: 15, type: "", unread: false };

export const getNotificationId = (value) => {
    if (!value) return "";
    if (typeof value.toHexString === "function") return value.toHexString();
    if (typeof value === "object") return getNotificationId(value._id || value.id);
    return String(value).trim();
};

export const isNotificationObjectId = (value) => /^[a-f\d]{24}$/i.test(getNotificationId(value));
export const getNotificationQueryId = (search, key) => {
    const id = new URLSearchParams(search).get(key) || "";
    return isNotificationObjectId(id) ? id.toLowerCase() : "";
};
export const formatNotificationCount = (value) => Number(value) > 99 ? "99+" : String(Math.max(0, Number(value) || 0));
export const getNotificationTypeLabel = (type) => notificationTypes.find((item) => item.key === type)?.label || "Система";

export const getNotificationCountForPath = (path, counts = {}) => {
    // У пункта «Финансы» счётчик общий: подписки и остальные оплаты.
    const types = {
        "/orders": ["order"], "/applicationPage": ["lead"], "/applicationsCallMe": ["lead"],
        "/users": ["user"], "/admin/billing": ["subscription"], "/admin/money": ["subscription", "payment"],
    }[path];
    return (types || []).reduce((sum, type) => sum + Math.max(0, Number(counts[type]) || 0), 0);
};

export const getNotificationStats = (payload = {}) => ({
    unreadCount: Math.max(0, Number(payload.unreadCount) || 0),
    unreadByType: Object.fromEntries(notificationTypes.filter((item) => item.key).map((item) => [
        item.key, Math.max(0, Number(payload.unreadByType?.[item.key]) || 0),
    ])),
});

export const matchesNotificationFilters = (notification, filters) => {
    if (filters.type && notification.type !== filters.type) return false;
    if (filters.unread && notification.isRead) return false;
    const time = new Date(notification.createdAt).getTime();
    if (filters.from && !(time >= new Date(`${filters.from}T00:00:00.000Z`).getTime())) return false;
    if (filters.to && !(time <= new Date(`${filters.to}T23:59:59.999Z`).getTime())) return false;
    return true;
};

export const sortNotifications = (items, sort) => items.slice().sort((left, right) => {
    const time = (new Date(left.createdAt).getTime() || 0) - (new Date(right.createdAt).getTime() || 0);
    const leftId = getNotificationId(left);
    const rightId = getNotificationId(right);
    const comparison = time || (leftId === rightId ? 0 : leftId > rightId ? 1 : -1);
    return sort === "asc" ? comparison : -comparison;
});

// Строим переход по id объекта: старый /admin/orders отсутствует в маршрутах веб-админки.
export const getAdminNotificationHref = (notification, user) => {
    const meta = notification.meta || {};
    const targets = {
        order: ["/orders", "notificationOrderId", meta.orderId || meta.targetId],
        lead: ["/applicationsCallMe", "notificationApplicationId", meta.applicationId || meta.targetId],
        user: ["/users", "notificationUserId", meta.registeredUserId || meta.targetId || meta.userId],
        subscription: ["/office-setting", "notificationOfficeId", meta.officeId || meta.targetId],
        chat: ["/chat", "", meta.chatId || meta.targetId],
        // Оплаты (пополнения, пакеты, сцены) ведут в раздел «Деньги».
        payment: ["/admin/money", "", ""],
    };
    const target = targets[notification.type];
    let href = "";
    if (target) {
        const [path, key, value] = target;
        const id = getNotificationId(value);
        href = path;
        if (isNotificationObjectId(id)) href += key ? `?${key}=${encodeURIComponent(id)}` : `/${id}`;
        else if (notification.type === "order") {
            const legacyId = String(notification.link || "").match(/^\/admin\/orders\/([a-f\d]{24})\/?$/i)?.[1];
            if (legacyId) href += `?notificationOrderId=${legacyId}`;
        }
    } else {
        const link = String(notification.link || "").trim();
        // Разрешаем только внутренние ссылки без управляющих символов и обратных слешей.
        if (/^\/(?!\/)/.test(link) && !/[\\\u0000-\u001f\u007f]/.test(link)) href = link;
    }
    return href && canAccessPath(user, href) ? href : "";
};
